// Collection Tabs Component JavaScript
// Handles tab switching and Swiper initialization

class CollectionTabs {
  constructor() {
    this.swiperInstances = {};
    this.tabHeaders = document.querySelectorAll(".b-collection-tabs__title");
    this.tabContents = document.querySelectorAll(".b-collection-tabs__content-item");
    this.resizeTimeout = null;
    
    this.init();
  }

  init() {
    if (this.tabHeaders.length === 0) return;
    
    this.bindEvents();
    this.initializeTabs();
    
    // Check hash after a small delay to ensure everything is loaded
    setTimeout(() => this.checkHashAndSwitchTab(), 200);
  }

  bindEvents() {
    // Tab click events
    this.tabHeaders.forEach(header => {
      header.addEventListener("click", (e) => {
        e.preventDefault();
        this.switchTab(header, false);
      });
    });

    // Hash change events
    window.addEventListener("hashchange", (e) => {
      e.preventDefault();
      this.checkHashAndSwitchTab();
    });

    // Page visibility change (helps with mobile/tablet refresh issues)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        setTimeout(() => {
          const activeTab = document.querySelector('.b-collection-tabs__title.active');
          const activeContent = document.querySelector('.b-collection-tabs__content-item.active');
          
          if (!activeContent || activeContent.style.display === 'none') {
            this.initializeTabs();
          } else {
            this.initializeVisibleSwipers();
          }
        }, 100);
      }
    });

    this._wasMobile = window.matchMedia('(max-width: 767px)').matches;

window.addEventListener('resize', () => {
  clearTimeout(this.resizeTimeout);
  this.resizeTimeout = setTimeout(() => {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile !== this._wasMobile) {
      Object.keys(this.swiperInstances).forEach(id => {
        const container = document.querySelector(`[data-swiper-id="${id}"]`);
        if (container) this.destroySwiper(container);
      });
      setTimeout(() => this.initializeVisibleSwipers(), 100);
      this._wasMobile = isMobile;
    } else {
      Object.values(this.swiperInstances).forEach(sw => sw.update());
    }
  }, 200);
});
  }

  normalizeTabId(tabName) {
    return tabName.replace(/\s+/g, '-').toLowerCase();
  }

  switchTab(selectedTab, shouldScroll = false) {
    // Remove active classes and destroy hidden swipers
    this.tabHeaders.forEach(header => header.classList.remove("active"));
    this.tabContents.forEach(content => {
      content.style.display = "none";
      content.classList.remove("active");
      
      // Destroy swipers in hidden tabs to prevent conflicts
      const swipers = content.querySelectorAll('.swiper-product');
      swipers.forEach(swiper => this.destroySwiper(swiper));
    });

    // Add active class to selected tab
    selectedTab.classList.add("active");
    
    // Show corresponding content
    const targetTab = this.normalizeTabId(selectedTab.getAttribute("data-tab"));
    const contentToShow = document.getElementById("tab-" + targetTab);
    
    if (contentToShow) {
      contentToShow.style.display = "block";
      contentToShow.classList.add("active");
      
      // Initialize swipers in the newly visible tab
      setTimeout(() => {
        const swipers = contentToShow.querySelectorAll('.swiper-product');
        swipers.forEach(swiper => this.initializeSwiper(swiper));
      }, 50);
      
      // Dispatch custom event for extensibility
      window.dispatchEvent(new CustomEvent('tabContentShown', { 
        detail: { tabId: targetTab, content: contentToShow }
      }));
    }

    if (shouldScroll) {
      this.scrollToSection();
    }
  }

  scrollToSection() {
    const currentHash = window.location.hash;
    history.replaceState(null, null, window.location.pathname + window.location.search);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const sectionElement = document.querySelector(".b-collection-tabs");
        if (sectionElement) {
          sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        history.replaceState(null, null, window.location.pathname + window.location.search + currentHash);
      });
    });
  }

  initializeTabs() {
    // Ensure at least one tab is active
    let activeTab = document.querySelector('.b-collection-tabs__title.active');
    if (!activeTab && this.tabHeaders.length > 0) {
      activeTab = this.tabHeaders[0];
      activeTab.classList.add('active');
    }
    
    // Show corresponding content for active tab
    if (activeTab) {
      const targetTab = this.normalizeTabId(activeTab.getAttribute("data-tab"));
      const contentToShow = document.getElementById("tab-" + targetTab);
      
      if (contentToShow) {
        contentToShow.style.display = "block";
        contentToShow.classList.add("active");
      }
    }
    
    // Hide all other content
    this.tabContents.forEach(content => {
      if (!content.classList.contains('active')) {
        content.style.display = "none";
      }
    });

    // Initialize swipers for visible content
    setTimeout(() => this.initializeVisibleSwipers(), 100);
  }

  checkHashAndSwitchTab() {
    if (window.location.hash) {
      const hashValue = window.location.hash.replace("#", "").toLowerCase();
      
      // Check if it's a main tab hash
      const header = document.querySelector('.b-collection-tabs__title[data-tab="' + hashValue + '"]');
      if (header) {
        this.switchTab(header, true);
        return;
      }
      
      // Check if it's a sub-section hash within a tab
      const targetElement = document.getElementById(hashValue);
      if (targetElement) {
        const parentTab = targetElement.closest('.b-collection-tabs__content-item');
        if (parentTab) {
          const tabId = parentTab.id.replace('tab-', '');
          const correspondingHeader = document.querySelector('.b-collection-tabs__title[data-tab="' + tabId + '"]');
          if (correspondingHeader) {
            this.switchTab(correspondingHeader, true);
            // Scroll to specific element after tab switch
            setTimeout(() => {
              targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 150);
            return;
          }
        }
      }
    }
    
    // No hash or hash not found, initialize default state
    this.initializeTabs();
  }

  // Swiper Management Methods
  initializeSwiper(container) {
    if (!container || this.swiperInstances[container.getAttribute('data-swiper-id')]) {
      return; // Already initialized or invalid container
    }

    // Only initialize on mobile/tablet
    if (window.matchMedia("(max-width: 767px)").matches) {
      const swiperId = container.getAttribute('data-swiper-id') || Math.random().toString(36).substr(2, 9);
      container.setAttribute('data-swiper-id', swiperId);

      try {
this.swiperInstances[swiperId] = new Swiper(container, {
  slidesPerView: 2,
  slidesPerGroup: 2,
  spaceBetween: 9,

  // optional: smoother first paint
  loop: false,

  // recheck when DOM changes
  observer: true,
  observeParents: true,

  // prevent jump while waiting for image decode
  preloadImages: false,
  lazy: { loadOnTransitionStart: true },
  watchSlidesProgress: true,

  pagination: { el: container.querySelector(".product-pagination") },
  navigation: {
    nextEl: container.querySelector(".button-next"),
    prevEl: container.querySelector(".button-prev"),
  },

  on: {
    init: (sw) => {
      container.classList.add('is-ready');
    },
    imagesReady: (sw) => {
      requestAnimationFrame(() => sw.update());
    }
  }
});

      } catch (error) {
        console.warn('Failed to initialize Swiper:', error);
      }
    }
  }

  initializeVisibleSwipers() {
    const visibleSwipers = document.querySelectorAll('.b-collection-tabs__content-item.active .swiper-product, .b-collection-tabs__content-item:first-child .swiper-product');
    visibleSwipers.forEach(swiper => this.initializeSwiper(swiper));
  }

  destroySwiper(container) {
    const swiperId = container.getAttribute('data-swiper-id');
    if (swiperId && this.swiperInstances[swiperId]) {
      try {
        this.swiperInstances[swiperId].destroy(true, true);
        delete this.swiperInstances[swiperId];
        container.removeAttribute('data-swiper-id');
      } catch (error) {
        console.warn('Failed to destroy Swiper:', error);
      }
    }
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function() {
  // Wait a bit longer to ensure Swiper is fully loaded
  setTimeout(() => {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not found. Please ensure Swiper.js is loaded before this script.');
      return;
    }
    
    // Initialize the collection tabs component
    new CollectionTabs();
  }, 100);
});